import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

const PassCard = ({ pass, index, festivalId, videoId }) => {
  const [busy, setBusy] = useState(false);
  const highlighted = pass.highlighted;

  const buy = async () => {
    if (pass.link) {
      window.open(pass.link, "_blank", "noopener");
      return;
    }
    setBusy(true);
    try {
      const { data } = await api.post("/payments/checkout", { festival_id: festivalId, pass_id: pass.id, video_id: videoId, origin_url: window.location.origin });
      window.location.href = data.checkout_url;
    } catch (e) {
      toast.error(errMsg(e));
      setBusy(false);
    }
  };

  return (
    <div
      className={`bg-white rounded-2xl border text-center px-5 md:px-6 transition-transform duration-300 ${
        highlighted ? "border-2 border-[#F8D481] py-8 md:py-10 shadow-[0_12px_32px_rgba(0,0,0,0.08)] lg:scale-[1.03]" : "border-[#E6E6E6] py-6 md:py-7 shadow-[0_2px_12px_rgba(0,0,0,0.03)]"
      }`}
      data-testid={`pass-card-${index}`}
    >
      <p className={`${highlighted ? "text-[34px]" : "text-[30px]"} font-bold leading-none`} data-testid="pass-price">
        {pass.price}
      </p>
      <p className="mt-2 text-[15px] font-semibold leading-tight" data-testid="pass-tier-name">
        {pass.tier_name}
      </p>
      {pass.features?.length > 0 && (
        <ul className="mt-5 space-y-1 text-[13.5px] font-medium text-[#333]">
          {pass.features.map((f, i) => (
            <li key={i} data-testid="pass-feature">
              <span className="mr-1.5">✓</span>
              {f}
            </li>
          ))}
        </ul>
      )}
      <button
        type="button"
        onClick={buy}
        disabled={busy}
        className="mt-7 w-full rounded-md bg-[#F8D481] hover:bg-[#f3c968] py-3 text-[16px] font-bold transition-colors disabled:opacity-70"
        data-testid="purchase-pass-button"
      >
        {busy ? "Redirecting…" : "Purchase Pass"}
      </button>
    </div>
  );
};

export const PassCards = ({ passes, festivalId, videoId }) => (
  <section id="passes" className="scroll-mt-[90px] lg:scroll-mt-[124px] pt-4" data-testid="festival-passes">
    <div
      className={`grid gap-5 items-center ${
        passes.length >= 3
          ? "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3"
          : passes.length === 2
            ? "grid-cols-1 sm:grid-cols-2 max-w-[640px] mx-auto"
            : "grid-cols-1 max-w-[320px] mx-auto"
      }`}
    >
      {passes.map((p, i) => (
        <PassCard key={p.id || i} pass={p} index={i} festivalId={festivalId} videoId={videoId} />
      ))}
    </div>
  </section>
);
